module.exports = __webpack_public_path__ + "img/zu25.6d747520.png";